<template>
  <div class="resource">
    <div class="title">
      <div class="title_name">资源定位分布</div>
      <div class="tabsSelect">
        <el-select v-model="resourceSelect"
                   @change="handleAllSearch"
                   slot="prepend"
                   placeholder="全部"
                   size="small">
          <el-option label="全部"
                     value="1"></el-option>
          <el-option label="工厂"
                     value="2"></el-option>
          <el-option label="货源"
                     value="3"></el-option>
          <el-option label="空车"
                     value="4"></el-option>
          <el-option label="重车"
                     value="5"></el-option>
        </el-select>
      </div>
    </div>
    <div class="resource_search"
         v-show="resourceSelect==='2'">
      <el-form :inline="true"
               :model="formInline"
               class="search_factory"
               label-position="right">
        <el-form-item label="工厂名称"
                      size="small">
          <el-input v-model="factory.name"
                    placeholder="请输入工厂名称"></el-input>
        </el-form-item>
        <el-form-item label="工厂源地址"
                      size="small">
          <el-input v-model="factory.address"
                    placeholder="请输入工厂源地址"></el-input>
        </el-form-item>
        <el-form-item class="itembtn"
                      size="small">
          <el-button class="search-submit"
                     type="primary"
                     @click="handleFactorySearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="resource_search"
         v-show="resourceSelect==='3'">
      <el-form :inline="true"
               :model="formInline"
               class="search_factory"
               label-position="right">
        <el-form-item label="货主公司"
                      size="small">
          <el-input v-model="billInfo.companyName"
                    placeholder="请输入货主公司"></el-input>
        </el-form-item>
        <!-- <el-form-item label="物流公司" size="small">
            <el-input v-model="billInfo.logisticsName" placeholder="请输入物流公司" ></el-input>
          </el-form-item> -->
        <el-form-item label="货源编号"
                      size="small">
          <el-input v-model="billInfo.goodsNo"
                    placeholder="请输入货源编号"></el-input>
        </el-form-item>
        <div class="addressStyle">
          <span class="imp">出发地</span>
          <el-cascader size="small"
                       @active-item-change="handleItemChange"
                       :options="options"
                       v-model="addressFrom"
                       @change="handleChangeFrom">
          </el-cascader>
        </div>
        <div class="addressStyle">
          <span class="imp">目的地</span>
          <el-cascader size="small"
                       :options="options"
                       v-model="addressTo"
                       @active-item-change="handleItemChange"
                       @change="handleChangeTo">
          </el-cascader>
        </div>

        <el-form-item class="itembtn"
                      size="small">
          <el-button class="search-submit"
                     type="primary"
                     @click="handleGoodsSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="resource_search"
         v-show="resourceSelect==='4'">
      <el-form :inline="true"
               :model="formInline"
               class="search_factory"
               label-position="right">
        <el-form-item label="物流公司"
                      size="small">
          <el-input v-model="carInfo.companyName"
                    placeholder="请输入物流公司"></el-input>
        </el-form-item>
        <el-form-item label="车头号"
                      size="small">
          <el-input v-model="carInfo.headNumber"
                    placeholder="请输入车头号"></el-input>
        </el-form-item>
        <el-form-item label="司机姓名"
                      size="small">
          <el-input v-model="carInfo.driverName"
                    placeholder="请输入司机姓名"></el-input>
        </el-form-item>
        <el-form-item class="itembtn"
                      size="small">
          <el-button class="search-submit"
                     type="primary"
                     @click="handleEmprySearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="resource_search"
         v-show="resourceSelect==='5'">
      <el-form :inline="true"
               :model="formInline"
               class="search_factory"
               label-position="right">
        <el-form-item label="物流公司"
                      size="small">
          <el-input v-model="carInfo.companyName"
                    placeholder="请输入物流公司"></el-input>
        </el-form-item>
        <el-form-item label="车头号"
                      size="small">
          <el-input v-model="carInfo.headNumber"
                    placeholder="请输入车头号"></el-input>
        </el-form-item>
        <el-form-item label="司机姓名"
                      size="small">
          <el-input v-model="carInfo.driverName"
                    placeholder="请输入司机姓名"></el-input>
        </el-form-item>
        <el-form-item class="itembtn"
                      size="small">
          <el-button class="search-submit"
                     type="primary"
                     @click="handleBusySearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="container"
         v-bind:class="resourceSelect==='1'?'container':resourceSelect==='3'?'container isBillstyle':'container isactive'">
      <div id="container"
           class="m-map"></div>
      <div class="map_title">
        <ul>
          <span class="icon_factory"></span>
          <li>工厂</li>
          <span class="icon_waybill"></span>
          <li>货源</li>
          <span class="icon_empty"></span>
          <li>空车</li>
          <span class="icon_full"></span>
          <li>重车</li>
        </ul>
      </div>
    </div>
    <!-- <el-dialog
        title="运输轨迹"
        :visible.sync="track"
        class="loadCarImg"
      >
        <div> 地图加载中</div>
        <div class="track_container" id="track_container">
        </div>
      </el-dialog> -->
    <div class="trackMask"
         v-show="track"
         @click="handleCloseMapClick">
    </div>
    <div class="trackContainer"
         v-show="track">
      <div class="track_header">运输轨迹<span class="track_close"
              @click="handleCloseMapClick"></span></div>
      <div class="track_main">
        <div id="track_container"></div>
      </div>
    </div>
  </div>
</template>
<script src="https://webapi.amap.com/maps?v=1.4.13&key=6656a8e9810da0328783e4c374223568"></script>
<script>
import {
  provinceList,
  cityList,
  areaList,
  sourceList,
  getTrack,
  factorySearch,//工厂查询
  goodsSearch,//货源查询
  emptyCarSearch,//空车查询
  busyCarSearch,//重车查询
} from 'apis/index'
export default {
  data () {
    return {
      searchInput: '',
      resourceSelect: '1',
      searchKey: '',
      placeSearch: null,
      dragStatus: false,
      formInline: {
        material: '',
        from: '',
        to: ''
      },
      factory: { // 工厂源查询
        name: '',
        address: ''
      },
      billInfo: { // 货源查询
        companyName: '',
        // logisticsName: '',
        goodsNo: ''
      },
      carInfo: { // 空车,重车查询
        companyName: '',
        driverName: '',
        headNumber: ''
      },
      options: [],
      addressFrom: [],
      addressTo: [],
      from: '',
      to: '',
      address: '',
      zoom: 5,
      track: false,
    }
  },
  methods: {
    async initData () { // 省市区三级联动
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
        // console.log('11')
      }
    },
    async handleItemChange (val) {
      // console.log('active item:', val)
      // console.log(val)
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
    },
    getAddressText (value) { // 获取地址
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.from = this.address
    },
    handleChangeTo (value) {
      this.getAddressText(value)
      this.to = this.address
    },
    handleAllSearch () {
      this.factory = { // 工厂源查询
        name: '',
        address: ''
      }
      this.billInfo = { // 货源查询
        companyName: '',
        // logisticsName: '',
        goodsNo: ''
      }
      this.carInfo = { // 空车,重车查询
        companyName: '',
        driverName: '',
        headNumber: ''
      }
      this.addressFrom = []
      this.addressTo = []
      if (this.resourceSelect === '1') {
        this.getData()
      } else if (this.resourceSelect === '2') {
        this.handleFactorySearch()
      } else if (this.resourceSelect === '3') {
        this.handleGoodsSearch()
      } else if (this.resourceSelect === '4') {
        this.handleEmprySearch()
      } else if (this.resourceSelect === '5') {
        this.handleBusySearch()
      }
    },
    handleFactorySearch () { //工厂查询
      factorySearch({
        factoryname: this.factory.name,
        departurename: this.factory.address
      }).then(res => {
        if (res.data.code === 200) {
          this.showMap(res.data.data)
        } else if (res.data.code === 201) {
          this.$message({
            showClose: true,
            message: '查询结果为空',
            type: 'warning'
          });
        }
      })

    },
    handleGoodsSearch () { //货源查询
      goodsSearch({
        companyName: this.billInfo.companyName,
        goodsNo: this.billInfo.goodsNo,
        departureName: this.from,
        destinationName: this.to
      }).then(res => {
        if (res.data.code === 200) {
          this.showMap(res.data.data)
        } else if (res.data.code === 201) {
          this.$message({
            showClose: true,
            message: '查询结果为空',
            type: 'warning'
          });
        }
      })
    },
    handleEmprySearch () { //空车查询
      emptyCarSearch({
        companyName: this.carInfo.companyName, //物流公司
        dirverName: this.carInfo.driverName, //司机姓名
        headNumber: this.carInfo.headNumber  //车头号
      }).then(res => {
        if (res.data.code === 200) {
          this.showMap(res.data.data)
        } else if (res.data.code === 201) {
          this.$message({
            showClose: true,
            message: '查询结果为空',
            type: 'warning'
          });
        }
      })
    },
    handleBusySearch () { //重车查询
      busyCarSearch({
        companyName: this.carInfo.companyName, //物流公司
        diverName: this.carInfo.driverName, //司机姓名
        headNumber: this.carInfo.headNumber  //车头号
      }).then(res => {
        if (res.data.code === 200) {
          this.showMap(res.data.data)
          // console.log('ss1',res.data.data)
        } else if (res.data.code === 201) {
          this.$message({
            showClose: true,
            message: '查询结果为空',
            type: 'warning'
          });
        }
      })
    },
    showMap (item) {
      // console.log(item)
      var map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: this.zoom
      });
      var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
      let data = item
      data.forEach(element => {
        // console.log(element)
        let _this = this
        if (element.type === '6') { //工厂
          if (element.lat && element.lng) {
            let lnglat = [element.lng, element.lat]
            var marker = new AMap.Marker({
              position: lnglat,
              map: map,
              icon: 'http://image.jsh178.com/FjaGOScwpC3Lxf-c2WqVuhcfmaLI'
            });
            marker.content = '工厂名称：' + element.name;
            marker.on('click', markerClick);
          }

        }
        else if (element.type === '3') { //货源

          // console.log(element)
          if (element.lng && element.lat) {
            let lnglat = [element.lng, element.lat]
            var marker = new AMap.Marker({
              position: lnglat,
              map: map,
              icon: 'http://image.jsh178.com/Fh_nkM90jzKbw0zELWicAIZw7Rt1'
            });
            marker.content = "<div><span class='label'>公司名称：</span>" + element.companyName + "</div>"
              + "<div><span class='label'>货源编号：</span>" + element.goods_no + "</div>"
              + "<div><span class='label'>原料：</span>" + element.material + " </div>"
              + "<div><span class='label'>重量：</span>" + element.orderWeight + "吨</div>"
              + "<div><span class='label'>出发地：</span>" + element.departureAddress + "</div>"
              + "<div><span class='label'>目的地：</span>" + element.destinationAddress + "</div>"
            marker.on('click', markerClick);
            marker.on('mouseover', markerCircle)
            // marker.on('mouseout',markerCircleOut)
            marker.on('mouseout', removeCircle)
            var circle = new AMap.Circle({
              center: lnglat,          //设置线覆盖物路径
              radius: 5000,
              radius: 500000,
              strokeColor: "#FF8D00", //边框线颜色
              strokeOpacity: 0.3,       //边框线透明度
              strokeWeight: 2,        //边框线宽
              fillColor: "#FF8D00", //填充色
              fillOpacity: 0.2//填充透明度
            })
          }

        }
        else if (element.type === '2') { //重车
          if (element.lng && element.lat) {
            // console.log('sss',element.goods_no,element.truckOrderId)
            let firstLongLat = [element.lng, element.lat]
            let scendLongLat = [element.scendlng, element.scendlat]
            console.log('first', firstLongLat)
            console.log('scend', scendLongLat)
            let lineList = [firstLongLat, scendLongLat]
            console.log('zhongche', lineList)
            // console.log(lineList)
            var marker = new AMap.Marker({
              map: map,
              position: scendLongLat,
              icon: "http://image.jsh178.com/FmQdHrf-kE2vPHc4AxAH1xHFl0qI",
              autoRotation: true,
            });
            // 绘制轨迹
            var polyline = new AMap.Polyline({
              map: map,
              path: lineList,
              showDir: true,
              strokeColor: "#28F",  //线颜色
              strokeOpacity: 0,     //线透明度
              strokeWeight: 6,      //线宽
              // strokeStyle: "solid"  //线样式
            });

            marker.content = "<div class='heavyCar'>"
              + "<div><span class='label'>公司名称：</span>" + element.companyName + "</div>"
              + "<div><span class='label'>运单编号：</span>" + element.orderNum + "</div>"
              + "<div><span class='label'>车头号：</span>" + element.truckHeadNo + "</div>"
              + "<div><span class='label'>车挂号：</span>" + element.truckEndNo + " 挂</div>"
              + "<div><span class='label'>核载量：</span>" + element.loadCapacity + "吨</div>"
              + "<div><span class='label'>状态：</span>重车</div>"
              + "<div><span class='label'>司机姓名：</span>" + element.driverName + "</div>"
              + "<div><span class='label'>司机电话：</span>" + element.driverPhone + "</div>"
              + "<div><span class='label'>时速：</span>" + element.speed + "</div>"
              + "<div><span class='label'>方向：</span>" + element.angle + "</div>"
              + "<div class='track' onclick='showTrackClick()' goods_no=" + element.goods_no + " truckOrderId=" + element.truckOrderId + ">查看轨迹</div>"
              + "<div class='more' onclick='showMoreClick(true)'>更多</div>"
              + "</div>"
            marker.on('click', markerClick);
            marker.moveAlong(lineList, 900000);
          }
        }
        else if (element.type === '1') { //空车
          console.log('sss', element)
          if (element.lng && element.lat) {

            let firstLongLat = [element.lng, element.lat]
            let scendLongLat = [element.scendlng, element.scendlat]
            let lineList = [firstLongLat, scendLongLat]

            // console.log(lineList)
            var marker = new AMap.Marker({
              map: map,
              position: scendLongLat,
              icon: "http://image.jsh178.com/Fgth9_wQwXB4NOs36zj4EpRqkiV8",
              autoRotation: true,
            });
            // 绘制轨迹
            var polyline = new AMap.Polyline({
              map: map,
              path: lineList,
              showDir: true,
              strokeColor: "#28F",  //线颜色
              strokeOpacity: 0,     //线透明度
              strokeWeight: 6,      //线宽
              // strokeStyle: "solid"  //线样式
            });
            marker.content = "<div><span class='label'>公司名称：</span>" + element.companyName + "</div>"
              + "<div><span class='label'>车头号：</span>" + element.truckHeadNo + "</div>"
              + "<div><span class='label'>车挂号：</span>" + element.truckEndNo + " </div>"
              + "<div><span class='label'>司机姓名：</span>" + element.driverName + "</div>"
              + "<div><span class='label'>司机电话：</span>" + element.driverPhone + "</div>"
              + "<div><span class='label'>核载量：</span>" + element.loadCapacity + "吨</div>"
              + "<div><span class='label'>状态：</span>空车</div>"
            marker.on('click', markerClick);
            marker.moveAlong(lineList, 900000);
          }
        }
        function markerClick (e) {
          infoWindow.setContent(e.target.content);
          infoWindow.open(map, e.target.getPosition());
          // var items = document.getElementsByClassName('clickme')[0]
          // console.log(items)
          // items.onclick=function(e){
          //   console.log('aaa',this.getAttribute('goods_no'))
          //   console.log('aaaaaa',e)
          //   _this.wahaha()

          // }
        }
        function markerCircle (e) {
          map.add(circle)
        }
        // function markerCircleOut(e){
        //  circle.off('dragging', markerCircle);
        // }
        function removeCircle (e) {
          // marker.off('mouseout',markerCircle)
          map.remove(circle);
        }
        window.showMoreClick = function (item) { //map更多
          // console.log('siongzhiwe',this)
          // isactive
          var items = document.getElementsByClassName('heavyCar')[0]
          var moreBtn = document.getElementsByClassName('more')[0]

          if (item) {
            items.className = 'heavyCar isactive'
            moreBtn.setAttribute('onclick', 'showMoreClick(false)')
            moreBtn.className = 'more isactive'
            moreBtn.innerHTML = '收回'
          } else {
            items.className = 'heavyCar'
            moreBtn.setAttribute('onclick', 'showMoreClick(true)')
            moreBtn.className = 'more'
            moreBtn.innerHTML = '更多'
          }
        },
          window.showTrackClick = function () { //显示轨迹
            let trackItem = document.getElementsByClassName('track')[0]
            // console.log(trackItem)
            let track_goods_no = trackItem.getAttribute('goods_no')
            let track_truckorderid = trackItem.getAttribute('truckorderid')
            // console.log('wahaha', track_goods_no, track_truckorderid)
            _this.track = true
            // var lnglat = new AMap.LngLat(116.397,39.918);
            // var map = new AMap.Map("track_container", {
            //     zoom: 14,
            //     center: lnglat,
            //     resizeEnable: true
            // });
            // var trackmap = new AMap.Map("track_container", {
            //   resizeEnable: true,
            //   zoom:12
            // });
            getTrack({
              goods_no: track_goods_no,
              truckOrderId: track_truckorderid
            }).then(res => {
              // console.log('aaa',res)
              if (res.data.code === 200) {
                let data = res.data.data
                _this.handleShowTrack(data)
              }

            })

          }
      });
    },
    getData () { // 获取地图所有资源
      sourceList().then(res => {
        if (res.data.code === 200) {
          this.showMap(res.data.data)
        }
      })
    },
    handleShowTrack (data) { //展示轨迹
      if (data) {
        let startPoint = [data.vhbResourceLocationList.lng, data.vhbResourceLocationList.lat]
        let endPoint = [data.vhbResourceLocationList.scendlng, data.vhbResourceLocationList.scendlat]
        let trackPoint = []
        data.location.forEach(element => {
          trackPoint.push([element.lng, element.lat])
        });
        var trackmap = new AMap.Map("track_container", {
          resizeEnable: true,
          center: trackPoint[trackPoint.length - 1],
          zoom: 9
        });
        // console.log(startPoint,endPoint,trackPoint)
        // console.log('ssss',trackPoint[0][0],trackPoint[0][1])
        var track_marker = new AMap.Marker({
          map: trackmap,
          position: trackPoint[0],
          icon: "http://image.jsh178.com/FmQdHrf-kE2vPHc4AxAH1xHFl0qI",
          offset: new AMap.Pixel(-2, -5),
          autoRotation: true,
          angle: -90,
        });
        // var polyline = new AMap.Polyline({
        //   map: trackmap,
        //   path: trackPoint,
        //   showDir:true,
        //   strokeColor: "#28F",  //线颜色
        //   strokeOpacity: 1,     //线透明度
        //   strokeWeight: 6,      //线宽
        //   // strokeStyle: "solid"  //线样式
        // });
        var passedPolyline = new AMap.Polyline({
          map: trackmap,
          path: trackPoint,
          strokeColor: "#28F",  //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6,      //线宽
          // strokeStyle: "solid"  //线样式
        });
        track_marker.moveAlong(trackPoint, 900000);
        var startIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(25, 34),
          // 图标的取图地址
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          // 图标所用图片大小
          imageSize: new AMap.Size(135, 40),
          // 图标取图偏移量
          imageOffset: new AMap.Pixel(-9, -3)
        });
        // 将 icon 传入 marker
        var startMarker = new AMap.Marker({
          position: startPoint,
          icon: startIcon,
          offset: new AMap.Pixel(-13, -30)
        });
        // 创建一个 icon
        var endIcon = new AMap.Icon({
          size: new AMap.Size(25, 34),
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          imageSize: new AMap.Size(135, 40),
          imageOffset: new AMap.Pixel(-95, -3)
        });

        // 将 icon 传入 marker
        var endMarker = new AMap.Marker({
          position: endPoint,
          icon: endIcon,
          offset: new AMap.Pixel(-13, -30)
        });
        trackmap.add([startMarker, endMarker]);
      }
    },
    handleCloseMapClick () { //关闭轨迹
      this.track = false
    }

  },
  mounted () {
    this.initData()
    this.getData()
    this.handleShowTrack()
  },
}
</script>

<style lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.resource
  height 100%
  padding 20px
  min-width 930px
  .title
    height 46px
    line-height 46px
    width 100%
    border-bottom 1px solid #cfd5dc
    .title_name
      width 200px
      float left
      text-indent 3em
      background url('../../assets/logo.png') no-repeat center left 10px
      background-size 20px 20px
    .tabsSelect
      float right
      padding-right 10px
      .el-select .el-input
        width 110px
      .input-with-select .el-input-group__prepend
        background #fff
  .resource_search
    margin-top 4px
    padding 0 70px 5px 20px
    position relative
    .el-table__header-wrapper, .el-form-item
      margin-bottom 10px
      margin-right 24px
      &:nth-last-child(1)
        margin-right 0
    .el-form-item__label
      font-size 12px
    .itembtn
      position absolute
      top 0px
      right 20px
      width auto
    .addressStyle
      display inline-block
      margin-right 22px
      .imp
        width 60px
        display inline-block
        color #606266
      .el-cascader
        width 185px
    .search-submit
      padding 6px 24px
      background #fff
      text-align right
      color $bgColor
      size12()
      &:hover
        background $bgColor
        color #fff
    .search_factory
      width 100%
  .container
    position relative
    background #fff
    height calc(100% - 60px)
    &.isactive
      height calc(100% - 115px)
    &.isBillstyle
      height calc(100% - 145px)
    .m-map
      width calc(100% - 20px)
      height calc(100% - 20px)
      padding 10px
    .amap-info-content
      position relative
      width 214px
      div
        margin-top 5px
      .heavyCar
        height 130px
        padding-bottom 25px
        overflow hidden
        &.isactive
          height auto
        .more
          position absolute
          bottom 0px
          left 0
          right 0
          text-align center
          line-height 18px
          cursor pointer
          background url('../../assets/images/01/more_icon.png') no-repeat center left 136px #fff
          &.isactive
            background url('../../assets/images/01/more_arrow_up.png') no-repeat center left 136px #fff
        .track
          position absolute
          bottom 18px
          left 0
          right 10px
          text-align right
          line-height 16px
          cursor pointer
          background #fff
          color #1B88EE
    .map_title
      position absolute
      top 10px
      right 24px
      width 262px
      height 30px
      z-index 1000
      background #fff
      ul
        padding-left 10px
        li
          float left
          line-height 30px
          margin-right 5px
        span
          float left
          line-height 30px
          width 30px
          height 30px
        .icon_factory
          background url('../../assets/images/04/icon_gong.png') no-repeat center center
        .icon_waybill
          background url('../../assets/images/04/icon_huo.png') no-repeat center center
        .icon_empty
          background url('../../assets/images/04/icon_kong_title.png') no-repeat center center
        .icon_full
          background url('../../assets/images/04/icon_zhong.png') no-repeat center center
  .trackMask
    position fixed
    top 0
    bottom 0
    left 0
    right 0
    background rgba(0, 0, 0, 0.4)
    z-index 200
  .trackContainer
    width 688px
    z-index 201
    height 446px
    position fixed
    top 50%
    left 50%
    margin-left -344px
    margin-top -223px
    background #fff
    .track_header
      width 100%
      height 42px
      background #1B88EE
      text-indent 1em
      line-height 42px
      font-size 16px
      color #fff
      .track_close
        width 42px
        height 42px
        background url('../../assets/images/01/close_icon.png') no-repeat center center
        cursor pointer
        position absolute
        right 0px
        &:hover
          background url('../../assets/images/01/tanluang_close.png') no-repeat center center
    .track_main
      width calc(100% - 20px)
      margin 10px auto
      height calc(100% - 62px)
      #track_container
        height 100%
  // .el-dialog
  // width 688px
  // .el-dialog__header
  // height 42px
  // padding 0 20px 0
  // text-align left
  // background #1b88ee
  // line-height 42px
  // .el-dialog__title
  // font-size 13px
  // color #fff
  // .el-dialog__headerbtn
  // top 12px
  // right 12px
  // .el-dialog__close
  // color #fff
  // font-size 20px
  // .el-dialog__body
  // height 404px
  // padding 12px
  // .track_container
  // height 100%
  @media screen and (min-width: 1470px)
    .container
      position relative
      background #fff
      height calc(100% - 60px)
      &.isactive
        height calc(100% - 115px)
      &.isBillstyle
        height calc(100% - 115px)
</style>
